export enum ChartUnit {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year'
}

export interface OptimizableStayStat {
  countStay: number
  countTodoDasIaRevaluableStay: number
  countOptimizableOpenedStay: number
  countOptimizableValidatedStay: number
  countOptimizableEditedStay: number
}

export interface StatPercent {
  prctRevaluableStay: string | number
  prctOpenedStay: string | number
  prctValidatedStay: string | number
  prctEditedStay: string | number
}